module.exports = __webpack_public_path__ + "img/contents_title_sub97.fa829475.png";